var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid"},[_c('router-view',{key:_vm.UARM_FORCE_RELOAD_ROUTER_KEY}),_vm._v(" "),_c('notifications',{attrs:{"speed":100}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }